export default "__VITE_ASSET__Bjtj2gb$__"